// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dropdown wrapper */
.rc-cascader-dropdown {
  position: absolute;
  background-color: white;
  z-index: 1300; /* Same as MUI popups */
  min-height: auto;
  border-radius: 4px;
}

.rc-cascader-dropdown-hidden {
    display: none;
}

/* Panel holding all menus */
.rc-cascader-menus {
  display: flex;
  flex-wrap: nowrap;
}

/* Individual menu column */
.rc-cascader-menu {
  flex: none;
  margin: 0;
  padding: 8px 0; /* Matches MUI menu vertical padding */
  list-style: none;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  height: auto;
  min-width: 200px; /* Close to MUI default menu width */
  overflow-y: auto;
  max-height: 300px;
}
.rc-cascader-menu:first-child {
  border-left: 0;
}

/* Scrollbar styling for WebKit browsers (Chrome, Edge, Safari) */
.rc-cascader-menu::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.rc-cascader-menu::-webkit-scrollbar-track {
  background: transparent;
}

.rc-cascader-menu::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.rc-cascader-menu::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* Firefox support */
.rc-cascader-menu {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

/* Menu items */
.rc-cascader-menu-item {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s;
  color: rgba(0, 0, 0, 0.87);
}
.rc-cascader-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.04); /* MUI hover */
}
.rc-cascader-menu-item-selected {
  background-color: rgba(25, 118, 210, 0.08); /* MUI selected (primary color) */
}
.rc-cascader-menu-item-active {
  background-color: rgba(25, 118, 210, 0.12); /* MUI active (hover on selected) */
}
.rc-cascader-menu-item-disabled {
  opacity: 0.38;
  pointer-events: none;
  cursor: default;
}

/* Label inside item */
.rc-cascader-menu-item-content {
  flex: 1 1;
  padding-right: 20px;
}

/* Expand submenu icon */
.rc-cascader-menu-item-expand-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
}

.rc-cascader-menu-item-expand-icon svg{
  vertical-align: middle;
}

/* Expand submenu loading icon */
@keyframes mui-spin {
  100% {
    transform: rotate(360deg);
  }
}

.spin {
  animation: mui-spin 1s linear infinite;
}

/* Checkbox (if used) */
.rc-cascader-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 18px;
  height: 18px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 2px;
  margin-right: 8px;
  background-color: #fff;
}
.rc-cascader-checkbox::after {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: '';
}
.rc-cascader-checkbox-checked::after {
  content: '✔';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}
.rc-cascader-checkbox-indeterminate::after {
  content: '−';
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

/* RTL support */
.rc-cascader-rtl {
  direction: rtl;
}
.rc-cascader-rtl .rc-cascader-menu {
  border-left: none;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.rc-cascader-rtl .rc-cascader-menu:first-child {
  border-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/rc-cascader.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa,EAAE,uBAAuB;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,SAAS;EACT,cAAc,EAAE,sCAAsC;EACtD,gBAAgB;EAChB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB,EAAE,oCAAoC;EACtD,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,qCAAqC,EAAE,cAAc;AACvD;AACA;EACE,0CAA0C,EAAE,iCAAiC;AAC/E;AACA;EACE,0CAA0C,EAAE,mCAAmC;AACjF;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB","sourcesContent":["/* Dropdown wrapper */\r\n.rc-cascader-dropdown {\r\n  position: absolute;\r\n  background-color: white;\r\n  z-index: 1300; /* Same as MUI popups */\r\n  min-height: auto;\r\n  border-radius: 4px;\r\n}\r\n\r\n.rc-cascader-dropdown-hidden {\r\n    display: none;\r\n}\r\n\r\n/* Panel holding all menus */\r\n.rc-cascader-menus {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n/* Individual menu column */\r\n.rc-cascader-menu {\r\n  flex: none;\r\n  margin: 0;\r\n  padding: 8px 0; /* Matches MUI menu vertical padding */\r\n  list-style: none;\r\n  border-left: 1px solid rgba(0, 0, 0, 0.12);\r\n  height: auto;\r\n  min-width: 200px; /* Close to MUI default menu width */\r\n  overflow-y: auto;\r\n  max-height: 300px;\r\n}\r\n.rc-cascader-menu:first-child {\r\n  border-left: 0;\r\n}\r\n\r\n/* Scrollbar styling for WebKit browsers (Chrome, Edge, Safari) */\r\n.rc-cascader-menu::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.rc-cascader-menu::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.rc-cascader-menu::-webkit-scrollbar-thumb {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  border-radius: 8px;\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n}\r\n\r\n.rc-cascader-menu::-webkit-scrollbar-thumb:hover {\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Firefox support */\r\n.rc-cascader-menu {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\r\n}\r\n\r\n/* Menu items */\r\n.rc-cascader-menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 6px 16px;\r\n  position: relative;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  transition: background-color 0.2s;\r\n  color: rgba(0, 0, 0, 0.87);\r\n}\r\n.rc-cascader-menu-item:hover {\r\n  background-color: rgba(0, 0, 0, 0.04); /* MUI hover */\r\n}\r\n.rc-cascader-menu-item-selected {\r\n  background-color: rgba(25, 118, 210, 0.08); /* MUI selected (primary color) */\r\n}\r\n.rc-cascader-menu-item-active {\r\n  background-color: rgba(25, 118, 210, 0.12); /* MUI active (hover on selected) */\r\n}\r\n.rc-cascader-menu-item-disabled {\r\n  opacity: 0.38;\r\n  pointer-events: none;\r\n  cursor: default;\r\n}\r\n\r\n/* Label inside item */\r\n.rc-cascader-menu-item-content {\r\n  flex: 1;\r\n  padding-right: 20px;\r\n}\r\n\r\n/* Expand submenu icon */\r\n.rc-cascader-menu-item-expand-icon {\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 18px;\r\n  color: rgba(0, 0, 0, 0.54);\r\n}\r\n\r\n.rc-cascader-menu-item-expand-icon svg{\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Expand submenu loading icon */\r\n@keyframes mui-spin {\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.spin {\r\n  animation: mui-spin 1s linear infinite;\r\n}\r\n\r\n/* Checkbox (if used) */\r\n.rc-cascader-checkbox {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: none;\r\n  width: 18px;\r\n  height: 18px;\r\n  border: 1px solid rgba(0, 0, 0, 0.23);\r\n  border-radius: 2px;\r\n  margin-right: 8px;\r\n  background-color: #fff;\r\n}\r\n.rc-cascader-checkbox::after {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  content: '';\r\n}\r\n.rc-cascader-checkbox-checked::after {\r\n  content: '✔';\r\n  font-size: 14px;\r\n  color: rgba(0, 0, 0, 0.87);\r\n}\r\n.rc-cascader-checkbox-indeterminate::after {\r\n  content: '−';\r\n  font-size: 14px;\r\n  color: rgba(0, 0, 0, 0.87);\r\n}\r\n\r\n/* RTL support */\r\n.rc-cascader-rtl {\r\n  direction: rtl;\r\n}\r\n.rc-cascader-rtl .rc-cascader-menu {\r\n  border-left: none;\r\n  border-right: 1px solid rgba(0, 0, 0, 0.12);\r\n}\r\n.rc-cascader-rtl .rc-cascader-menu:first-child {\r\n  border-right: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
